import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FeedbackForm from "../components/FeedbackForm";

const predefinedFormats = [
  { label: "ISO (YYYY-MM-DDTHH:mm:ssZ)", format: "toISOString" },
  { label: "UTC String", format: "toUTCString" },
  { label: "Locale String", format: "toLocaleString" },
  { label: "Date Only", format: "toDateString" },
  { label: "Time Only", format: "toTimeString" },
  { label: "Custom (YYYY/MM/DD HH:mm:ss)", format: "custom" },
];

const DateTimeConverter = () => {
  const [input, setInput] = useState("");
  const [format, setFormat] = useState("toISOString");
  const [result, setResult] = useState("");
  const [suggestion, setSuggestion] = useState("");
  const [interpretAsNumber, setInterpretAsNumber] = useState(false);

  const parseInput = (value) => {
    if (interpretAsNumber) {
      const numeric = value.split(/[\\s\\/,:-]+/)[0];
      let timestamp = parseInt(numeric);
      if (!isNaN(timestamp)) {
        if (timestamp > 1e12) timestamp = Math.floor(timestamp / 1000);
        if (timestamp < 1e10) timestamp *= 1000;
        return new Date(timestamp);
      }
    }
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  };

  const formatDate = (date) => {
    if (!date) return "Invalid date";
    if (format === "custom") {
      return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
    }
    return date[format]();
  };

  const handleConvert = () => {
    const date = parseInput(input);
    if (!date) {
      setResult("Invalid input");
      setSuggestion("Try a valid timestamp, number, or recognizable date string.");
    } else {
      setResult(formatDate(date));
      setSuggestion("Looks good! Date parsed correctly.");
    }
  };

  return (
    <div className="page-container">
      <Header title="Date Time Converter" subtitle="Convert timestamps or strings into various human-readable formats." meta={{
        title: "Date Converter – Timestamp to Readable Date",
        description: "Convert Unix timestamps, date strings, and custom formats into readable dates.",
        keywords: "date converter, unix timestamp, datetime tool",
        author: "My Online Tools"
      }} />
      <main className="content-wrapper">
        <div style={{ maxWidth: 800, margin: "auto" }}>
          <h2 style={{ textAlign: "center" }}>🕓 Date & Time Converter</h2>

          <label>Enter timestamp or date string</label>
          <input
            type="text"
            placeholder="e.g., 1672531199000 or 2/25/2025 or 2023-01-01T00:00:00Z"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            style={{ width: "100%", padding: "1rem", margin: "0.5rem 0", fontSize: "1rem" }}
          />

          <div style={{ margin: "0.5rem 0" }}>
            <label>
              <input
                type="checkbox"
                checked={interpretAsNumber}
                onChange={(e) => setInterpretAsNumber(e.target.checked)}
                style={{ marginRight: "0.5rem" }}
              />
              Interpret as number (auto-detect ms/sec from input)
            </label>
          </div>

          <label>Select Format</label>
          <select
            value={format}
            onChange={(e) => setFormat(e.target.value)}
            style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }}
          >
            {predefinedFormats.map((f) => (
              <option key={f.format} value={f.format}>{f.label}</option>
            ))}
          </select>

          <button onClick={handleConvert} style={{ marginTop: "1rem", padding: "0.75rem 1.5rem" }}>
            Convert
          </button>

          <div style={{ marginTop: "2rem" }}>
            <h3>Result:</h3>
            <div style={{ background: "#f4f4f4", padding: "1rem", borderRadius: "6px" }}>{result}</div>
            <p style={{ fontStyle: "italic", marginTop: "0.5rem" }}>{suggestion}</p>
          </div>
        </div>
        <FeedbackForm />
      </main>
      <Footer footerText="© 2025 My Online Tools — All rights reserved." />
    </div>
  );
};

export default DateTimeConverter;